import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Star, Trash2 } from "lucide-react";
import { api } from "../../lib/api";

const opts = { withCredentials: true };

export const Stars = ({ n, size = 13 }) => (
  <span className="inline-flex gap-0.5">{[1, 2, 3, 4, 5].map((i) => <Star key={i} size={size} className={i <= n ? "fill-[#9E4735] text-[#9E4735]" : "text-[#D1CFC7]"} />)}</span>
);

export const ReviewsList = () => {
  const [items, setItems] = useState([]);
  const load = () => api.get("/admin/book-reviews", opts).then((r) => setItems(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);
  const remove = (r) => window.confirm("Supprimer cet avis ?") && api.delete(`/admin/book-reviews/${r.id}`, opts).then(() => { toast.success("Avis supprimé"); load(); });
  return (
    <section data-testid="reviews-list" className="mt-12 font-body">
      <h3 className="font-serif text-2xl font-light mb-1">Avis des lecteurs</h3>
      <p className="text-xs text-[#757575] mb-4">Une demande d'avis est envoyée automatiquement par e-mail 7 jours après chaque achat numérique (chaque matin à 9 h, heure de Douala).</p>
      {items.length === 0 ? <p data-testid="reviews-empty" className="text-sm text-[#757575]">Aucun avis pour l'instant.</p> : (
        <ul className="space-y-3">
          {items.map((r) => (
            <li key={r.id} data-testid={`review-item-${r.id}`} className="border border-[#D1CFC7] p-4 flex gap-4">
              <div className="flex-1">
                <p className="flex flex-wrap items-center gap-2 text-sm"><Stars n={r.rating} /> <strong>{r.title}</strong> <span className="text-[#757575]">· {r.buyer} · {new Date(r.updated_at || r.created_at).toLocaleDateString("fr-FR")}</span></p>
                {r.comment && <p className="text-sm text-[#1A1A1A] mt-2 whitespace-pre-line">« {r.comment} »</p>}
              </div>
              <button onClick={() => remove(r)} data-testid={`review-delete-${r.id}`} className="text-[#9E4735] self-start"><Trash2 size={14} /></button>
            </li>
          ))}
        </ul>
      )}
    </section>
  );
};
